<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    hide-selected
    hide-no-data
    no-filter
    multiple
    chips
    small-chips
    deletable-chips
    item-value="id"
    item-text="pessoa.nome"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-list-item-content>
          <v-list-item-title v-text="item.item.pessoa.nome"/>
          <v-list-item-subtitle>
            <px-fornecedor-documento :fornecedor="item.item"/>
          </v-list-item-subtitle>
          <v-list-item-subtitle v-text="endereco(item.item)"/>
        </v-list-item-content>
        <v-list-item-action v-if="item.item.codigoInterno">
          <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        </v-list-item-action>
      </slot>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        {{ item.item.pessoa.nome }}
        <v-btn small icon @click="onRemoveItem(item.index)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import FornecedorService from '@/api/fornecedor-service';
import { formatCnpj, hasAnyLetter } from '@/utils/regex-utils';
import { computeEndereco } from '@/utils/endereco-utils';

const DEFAULT_LIMIT = 15;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Array,
    path: {
      type: String,
      default: 'fornecedor/score',
    },
    searchInCotacao: {
      type: Boolean,
      default: false,
    },
    searchInCompra: {
      type: Boolean,
      default: false,
    },
    searchInRequisicao: {
      type: Boolean,
      default: false,
    },
    searchByCodigoInterno: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Fornecedor',
    },
    cotacoes: Array,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    endereco() {
      return fornecedor => computeEndereco(fornecedor.endereco);
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.nome === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    getCotacoes() {
      if (!this.cotacoes || !this.cotacoes.length) {
        return undefined;
      }
      return this.cotacoes.map(cot => cot.id).join(',');
    },
    buildFilter(val) {
      const text = val || '';
      const cnpjQuery = !hasAnyLetter(text) ? ` or cnpj like "${formatCnpj(text)}%" or documento like "%${formatCnpj(text)}%"` : '';
      const filter = `nome like "%${text.toLowerCase()}%"${cnpjQuery}`;
      return `${filter} order by nome`;
    },
    searchFornecedores(val) {
      this.loading = true;

      FornecedorService.getFornecedores(this.path, {
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildFilter(val),
        codigoInterno: this.searchByCodigoInterno && val ? val.toLowerCase() : undefined,
        searchInCotacao: this.searchInCotacao ? this.searchInCotacao : undefined,
        searchInCompra: this.searchInCompra ? this.searchInCompra : undefined,
        searchInRequisicao: this.searchInRequisicao ? this.searchInRequisicao : undefined,
        cotacoes: this.getCotacoes(),
      })
        .then((response) => {
          this.items = response.data.content ? response.data.content : response.data;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
    },
    onRemoveItem(index) {
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchFornecedores, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
